'use client';

import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import SuperTokens from 'supertokens-auth-react/ui';

import { PreBuiltUIList } from '@/services/config/frontend';

import { AuthFormSkeleton } from './auth-form-skeleton';

type AuthComponentProps = {
  className?: string;
};

export const AuthComponent = ({ className }: AuthComponentProps) => {
  const [authContent, setAuthContent] = useState<ReactNode>(null);

  useEffect(() => {
    // SuperTokens recipes are initialised browser-side only — defer to mount.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setAuthContent(
      SuperTokens.getRoutingComponent(PreBuiltUIList) as ReactNode
    );
  }, []);

  if (!authContent) return <AuthFormSkeleton />;

  if (!className) {
    return authContent;
  }

  return <div className={className}>{authContent}</div>;
};
